<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="80px"
          class="search-form oneline"
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="名称" prop="query">
            <el-input
              v-model="filter.query"
              placeholder="名称"
              @keyup.enter.native="
                filter.page = 1
                getData()
              "
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="panel">
      <el-tabs v-model="filter.code_type" v-if="category == 2">
        <el-tab-pane label="有编号分类" name="1"></el-tab-pane>
        <el-tab-pane label="无编号分类" name="2"></el-tab-pane>
      </el-tabs>
      <TemplateGroup
        v-model="filter.group_id"
        :type="category"
        :codeType="parseInt(filter.code_type)"
        :canDelete="items.list.length == 0"
      ></TemplateGroup>
      <el-button
        class="mt-20"
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="formerVisible = true"
        v-permission="
          category == 1 ? Auth.productTemplateNew : Auth.instrumentTemplateNew
        "
        >添加分类</el-button
      >
      <item-table
        :items="items.list"
        :category="category"
        :codeType="parseInt(filter.code_type)"
        v-loading="loading"
      ></item-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
    <item-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
    ></item-former>
  </div>
</template>

<script>
import { productTemplateList } from '@/service/getData'
import ItemTable from './table'
import ItemFormer from './former'
import TemplateGroup from './group.vue'
export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ItemTable,
    ItemFormer,
    TemplateGroup,
  },
  watch: {
    'filter.group_id': function () {
      this.model.template_group_id = this.filter.group_id
      this.model.code_type = parseInt(this.filter.code_type)
      this.filter.page = 1
      this.getData()
    },
  },
  data() {
    return {
      loading: false,
      filter: { query: '', page: 1, size: 10, group_id: 0, code_type: '1' },
      activeName: 'first',
      model: {
        name: '',
        template_group_id: '',
        asset_type: 1,
        code_type: 1,
        item_template_ids: [],
        children_groups: null,
        custom_params: [],
        category: this.category,
        warning_current_day: 0,
        warning_condition_type: 1,
        warning_current_hour: 0,
        remark: '',
      },
      formerVisible: false,
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    // if (this.$route.query.filter) {
    //   this.filter = JSON.parse(this.$route.query.filter)
    // }
    // this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })
      let data = {
        page: this.filter.page - 1,
        size: this.filter.size,
        query: this.filter.query,
        category: this.category,
        group_id: this.filter.group_id,
        code_type: this.filter.code_type,
      }
      this.loading = true
      let res = await productTemplateList(data)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
    createdCallback(item) {
      this.items.list.unshift(item)
    },
  },
}
</script>